import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { ISection, SectionTypes } from '../../types';
import { DescriptionSectionViewModel } from '../../../../service-page-view-model/description-section-view-modal/descriptionSectionViewModel';
import Section from '../Section';
import SectionTitle from '../SectionTitle/SectionTitle';
import SectionText from '../SectionText/SectionText';
import settingsParams from '../../settingsParams';
import { useSettings } from '@wix/tpa-settings/react';
import { classes } from './Description.st.css';

type DescriptionProps = {
  viewModel?: DescriptionSectionViewModel;
  section: ISection;
};

export default ({ viewModel, section }) => {
  const { t } = useTranslation();
  const settings = useSettings();
  const withBookButton = section.bookButton && viewModel?.isBookable;

  return withBookButton || viewModel?.description ? (
    <Section
      sectionType={SectionTypes.DESCRIPTION}
      withBookButton={withBookButton}
    >
      {viewModel?.description && (
        <div data-hook="description-wrapper">
          <SectionTitle
            title={
              settings.get(settingsParams.descriptionTitleText) ||
              t('app.description.title')
            }
            dataHook="description-title"
          />
          <SectionText
            text={viewModel.description}
            className={classes.description}
            dataHook="description"
          />
        </div>
      )}
    </Section>
  ) : null;
};
